/**
 * §13 / §27.7 — marka işareti (DXP yelkeni).
 *
 * Üst çubukta, giriş kartında ve davet kartında AYNI çizim kullanılır; SVG'yi üç
 * dosyada kopyalamak yerine tek bileşende tutulur — marka değişirse tek yerde değişir.
 * Renk marka turuncusudur (#F66C04, §13 palet); ölçü çağıranın verdiği piksel.
 */

export interface BrandMarkProps {
  /** Yükseklik/genişlik ipucu (px). Üst çubuk 20, auth kartları 28 kullanır. */
  size?: number;
  className?: string;
}

export default function BrandMark({ size = 20, className = '' }: BrandMarkProps) {
  return (
    <svg
      width={size}
      height={Math.round((size * 21) / 20)}
      viewBox="0 0 23 24"
      fill="none"
      aria-hidden="true"
      className={className}
    >
      <path
        d="M19.3755 2.58551L18.0785 0L17.5417 0.275981C16.4557 0.834169 12.9355 2.69341 9.53204 4.49248L9.37221 4.57755C5.66144 6.53847 1.82363 8.5658 0.536843 9.22774L0 9.50372L1.38309 12.2615L1.2622 15.3906L1.86256 15.4135C6.40933 15.594 10.4029 18.6609 11.7962 23.0476L11.9806 23.6286L14.8841 22.6803L17.8756 23.3381L22.1786 3.2018L19.3755 2.58551ZM16.7364 3.41968L16.1668 19.3104C13.4948 15.4612 9.10584 13.1579 4.46891 13.1579H4.27016C5.85405 11.9315 8.28828 10.0246 10.6508 8.17361L10.7573 8.09476C13.0215 6.32267 15.3594 4.49248 16.7364 3.42175V3.41968Z"
        fill="#F66C04"
      />
    </svg>
  );
}
